import { useState } from 'react';
import { toast } from 'react-toastify';
import { useConfig } from '../Providers/ConfigProvider';
import { GetDocumentPdf } from '../Services/InvoiceService';

const useDownloadFinanceDocuments = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { api } = useConfig()

    const downloadFinanceDocument = async (docNo, docDate, siteId) => {
        try {
            setIsLoading(true);

            const response = await GetDocumentPdf(api, docNo, docDate, siteId);

            if (response.data.size === 0) {
                toast.error('Brak pliku do pobrania!');
                throw new Error("Plik jest pusty!");
            }

            // Otwieramy PDF w nowej karcie
            /* const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
            window.open(url, "_blank"); // Nowa karta */

            //Pobieramy plik PDF
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${docNo}_${docDate}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            toast.success('Pomyślnie pobrano plik');
        } catch (error) {
            console.error('Błąd pobierania pliku:', error);
            toast.error('Brak pliku do pobrania!');
        } finally {
            setIsLoading(false);
        }
    };

    return { downloadFinanceDocument, isLoading };
};

export default useDownloadFinanceDocuments;
